import { View, Text } from "react-native";
import React from "react";
import { showDifficultyIt } from "../utils/translation";
import { Problem } from "../types/Problem";

const DifficultyText = ({ problem }: { problem: Problem }) => {
	const difficulty = problem.difficulty;
	switch (difficulty) {
		case "very-easy":
			return (
				<Text className="text-lg self-end text-[#c3e88d]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		case "easy":
			return (
				<Text className="text-lg self-end text-[#93b85d]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		case "medium":
			return (
				<Text className="text-lg self-end text-[#f78c6c]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		case "hard":
			return (
				<Text className="text-lg self-end text-[#f07178]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		case "very-hard":
			return (
				<Text className="text-lg self-end text-[#ff5370]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
		default:
			return (
				<Text className="text-lg self-end text-[#ffffff]">
					{showDifficultyIt(difficulty)}
				</Text>
			);
	}
};

export default DifficultyText;
